import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { LoadingLogo } from './LoadingLogo';

type LoadingOverlayProps = {
  isVisible: boolean;
  portalRootId: string;
};

export const LoadingOverlay = ({ isVisible, portalRootId }: LoadingOverlayProps) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const sectionElement = document.getElementById(portalRootId);
    setPortalRoot(sectionElement);
  }, [portalRootId]);

  useEffect(() => {
    const scrollableContainer = document.querySelector('[style*="--content-height"]');
    if (scrollableContainer) {
      (scrollableContainer as HTMLElement).style.overflow = isVisible ? 'hidden' : '';
    }

    return () => {
      if (scrollableContainer) {
        (scrollableContainer as HTMLElement).style.overflow = '';
      }
    };
  }, [isVisible]);

  if (!isVisible || !portalRoot) {
    return null;
  }

  return createPortal(
    <div
      className="absolute inset-0 z-[90] flex items-center justify-center backdrop-blur-sm"
      data-testid="loading-overlay"
    >
      <div className="size-20">
        <LoadingLogo />
      </div>
    </div>,
    portalRoot,
  );
};
